export function stringifyMockJson(value: unknown, space?: number): string {
  return (
    JSON.stringify(
      value,
      (_key, nestedValue: unknown) =>
        typeof nestedValue === "bigint" ? nestedValue.toString() : nestedValue,
      space,
    ) ?? "null"
  );
}
